module.exports = __webpack_public_path__ + "img/1.f9ce22b3.jpg";